import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import CreateRecipe from './CreateRecipe.js'


// voor insp voor JSON-ld, zie notes folder van DC, notes/DieetClub/images/recipes
class CRUDRecipes extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "recipe_list", "GET", config.api_url+"/recipe-list?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "recipe_list", "GET", config.api_url+"/recipe-list?t="+nextProps.session_token);
    }
  }

  render() {
    let recipes_card = null, recipe_data = this.props.apiData["recipe_list"];

    if(recipe_data !== undefined) {
      let recipes = [];
      if(recipe_data.data[0] !== undefined) {
        recipes = recipe_data.data.map(function(item, i) {
          // 1-op-1 van Notes.js
          // dit soort loops/functies/cleaners/decorators ook naar Skelet denk ik.
          // let mapped_text = null; // mss een andere naam dan "wrapped", en in de mapper "item" aanpassen. (mss "mapped_description"?)
          // if(item.text !== "") {
          //   mapped_text = item.text.split('\n').map(function(item, key) {
          //     // item = item.replace(new RegExp(" ", 'g'), String.fromCharCode(160)); // this assures proper rendering of offset spaces.
          //     let new_item = "", first_nonspace = false;
          //     for (let i = 0; i < item.length; i++) {
          //       if(item.charAt(i) === " " && !first_nonspace) {
          //         new_item = new_item + String.fromCharCode(160);
          //       } else {
          //         first_nonspace = true;
          //         new_item = new_item + item.charAt(i);
          //       }
          //     }
          //     item = new_item;
          //     return <span key={key}>{item}<br/></span>;
          //   });
          // }
          // 1-op-1 van Notes.js

          let cd = new Date(item.created_at);
          let created_at_txt = cd.getDate()+" "+cd.toLocaleString('default', { month: 'long' })+" "+cd.getFullYear()+" "+('0'+cd.getHours()).slice(-2)+":"+('0'+cd.getMinutes()).slice(-2)+":"+('0'+cd.getSeconds()).slice(-2);
          let ud = new Date(item.updated_at);
          let updated_at_txt = ud.getDate()+" "+ud.toLocaleString('default', { month: 'long' })+" "+ud.getFullYear()+" "+('0'+ud.getHours()).slice(-2)+":"+('0'+ud.getMinutes()).slice(-2)+":"+('0'+ud.getSeconds()).slice(-2);
          let item_link = "/recept/"+item.title.replace(/ /g, "-").replace("#-", "").replace(/#/g, "").replace(/,/g, "")+"-"+item.ref_id;
          let item_status_txt = "Concept";
          if(item.status === 1) item_status_txt = "Publiek";
          if(item.status === 2) item_status_txt = "Club";

          return <div key={"1k"+i} className="card">
            {item.img_fn && <div><img src={"https://images.dieet.club/"+item.img_fn} alt="header preview" style={{maxWidth:"100%", marginBottom:"20px"}} /></div>}
            <div style={{marginBottom:"20px"}}><b>{item.title}</b></div>
            <div style={{marginBottom:"20px"}}>{item.json}</div>
            <div style={{opacity:".5", textAlign:"right"}}><small>created: {created_at_txt}</small></div>
            <div style={{opacity:".5", textAlign:"right"}}><small>updated: {updated_at_txt}</small></div>
            <div style={{opacity:".7", textAlign:"right", fontWeight:"bold"}}><small>status: {item_status_txt}</small></div>
            {item.original_link && <div style={{opacity:".5", textAlign:"right", fontWeight:"bold", fontSize:"110%"}}><small>{item.original_link}</small></div>}
            <div style={{textAlign:"right"}}>
              {item.status === 1 && <a href={item_link} target="_blank" className="btn btn-e">bekijk op Dieet.Club</a>}
            </div>
          </div>;
        });
      } else {
        recipes.push(<div key={"2k"}><p style={{opacity:".5"}}>Voeg je eerste recept toe.</p></div>);
      }

      recipes_card = <div>{recipes}</div>;
    }

    return (
      <div className="container" style={{marginTop:"2em"}}>
        <CreateRecipe />
        <div style={{border:"2px solid #ddd", color:"#ccc", padding:".8em"}}>description, keywords, <b>recipeIngredient</b>, prepTime, cookTime, totalTime, recipeYield, recipeCategory, recipeCuisine, <b>recipeInstructions</b>. (andere items zoals name, image en datePublished worden later toegevoegd.)</div>
        {recipes_card}
      </div>
    );
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CRUDRecipes)



// WEBPACK FOOTER //
// ./src/containers/CRUDRecipes.js